import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const loaderContainerStyle = css`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(1)};
`;
